export default "__VITE_ASSET__787357ba__"